const thaiPattern = /[\u0E00-\u0E7F]/;

function safeAdd(x: number, y: number): number {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

function bitRotateLeft(num: number, cnt: number): number {
  return (num << cnt) | (num >>> (32 - cnt));
}

function md5cmn(q: number, a: number, b: number, x: number, s: number, t: number): number {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}

function md5gg(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}

function md5hh(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a: number, b: number, c: number, d: number, x: number, s: number, t: number): number {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

function md5blk(input: string): number[] {
  const block = new Array<number>(16);
  for (let i = 0; i < 64; i += 4) {
    block[i >> 2] =
      input.charCodeAt(i) +
      (input.charCodeAt(i + 1) << 8) +
      (input.charCodeAt(i + 2) << 16) +
      (input.charCodeAt(i + 3) << 24);
  }
  return block;
}

function md5cycle(state: number[], block: number[]): void {
  let [a, b, c, d] = state;

  a = md5ff(a, b, c, d, block[0], 7, -680876936);
  d = md5ff(d, a, b, c, block[1], 12, -389564586);
  c = md5ff(c, d, a, b, block[2], 17, 606105819);
  b = md5ff(b, c, d, a, block[3], 22, -1044525330);
  a = md5ff(a, b, c, d, block[4], 7, -176418897);
  d = md5ff(d, a, b, c, block[5], 12, 1200080426);
  c = md5ff(c, d, a, b, block[6], 17, -1473231341);
  b = md5ff(b, c, d, a, block[7], 22, -45705983);
  a = md5ff(a, b, c, d, block[8], 7, 1770035416);
  d = md5ff(d, a, b, c, block[9], 12, -1958414417);
  c = md5ff(c, d, a, b, block[10], 17, -42063);
  b = md5ff(b, c, d, a, block[11], 22, -1990404162);
  a = md5ff(a, b, c, d, block[12], 7, 1804603682);
  d = md5ff(d, a, b, c, block[13], 12, -40341101);
  c = md5ff(c, d, a, b, block[14], 17, -1502002290);
  b = md5ff(b, c, d, a, block[15], 22, 1236535329);

  a = md5gg(a, b, c, d, block[1], 5, -165796510);
  d = md5gg(d, a, b, c, block[6], 9, -1069501632);
  c = md5gg(c, d, a, b, block[11], 14, 643717713);
  b = md5gg(b, c, d, a, block[0], 20, -373897302);
  a = md5gg(a, b, c, d, block[5], 5, -701558691);
  d = md5gg(d, a, b, c, block[10], 9, 38016083);
  c = md5gg(c, d, a, b, block[15], 14, -660478335);
  b = md5gg(b, c, d, a, block[4], 20, -405537848);
  a = md5gg(a, b, c, d, block[9], 5, 568446438);
  d = md5gg(d, a, b, c, block[14], 9, -1019803690);
  c = md5gg(c, d, a, b, block[3], 14, -187363961);
  b = md5gg(b, c, d, a, block[8], 20, 1163531501);
  a = md5gg(a, b, c, d, block[13], 5, -1444681467);
  d = md5gg(d, a, b, c, block[2], 9, -51403784);
  c = md5gg(c, d, a, b, block[7], 14, 1735328473);
  b = md5gg(b, c, d, a, block[12], 20, -1926607734);

  a = md5hh(a, b, c, d, block[5], 4, -378558);
  d = md5hh(d, a, b, c, block[8], 11, -2022574463);
  c = md5hh(c, d, a, b, block[11], 16, 1839030562);
  b = md5hh(b, c, d, a, block[14], 23, -35309556);
  a = md5hh(a, b, c, d, block[1], 4, -1530992060);
  d = md5hh(d, a, b, c, block[4], 11, 1272893353);
  c = md5hh(c, d, a, b, block[7], 16, -155497632);
  b = md5hh(b, c, d, a, block[10], 23, -1094730640);
  a = md5hh(a, b, c, d, block[13], 4, 681279174);
  d = md5hh(d, a, b, c, block[0], 11, -358537222);
  c = md5hh(c, d, a, b, block[3], 16, -722521979);
  b = md5hh(b, c, d, a, block[6], 23, 76029189);
  a = md5hh(a, b, c, d, block[9], 4, -640364487);
  d = md5hh(d, a, b, c, block[12], 11, -421815835);
  c = md5hh(c, d, a, b, block[15], 16, 530742520);
  b = md5hh(b, c, d, a, block[2], 23, -995338651);

  a = md5ii(a, b, c, d, block[0], 6, -198630844);
  d = md5ii(d, a, b, c, block[7], 10, 1126891415);
  c = md5ii(c, d, a, b, block[14], 15, -1416354905);
  b = md5ii(b, c, d, a, block[5], 21, -57434055);
  a = md5ii(a, b, c, d, block[12], 6, 1700485571);
  d = md5ii(d, a, b, c, block[3], 10, -1894986606);
  c = md5ii(c, d, a, b, block[10], 15, -1051523);
  b = md5ii(b, c, d, a, block[1], 21, -2054922799);
  a = md5ii(a, b, c, d, block[8], 6, 1873313359);
  d = md5ii(d, a, b, c, block[15], 10, -30611744);
  c = md5ii(c, d, a, b, block[6], 15, -1560198380);
  b = md5ii(b, c, d, a, block[13], 21, 1309151649);
  a = md5ii(a, b, c, d, block[4], 6, -145523070);
  d = md5ii(d, a, b, c, block[11], 10, -1120210379);
  c = md5ii(c, d, a, b, block[2], 15, 718787259);
  b = md5ii(b, c, d, a, block[9], 21, -343485551);

  state[0] = safeAdd(a, state[0]);
  state[1] = safeAdd(b, state[1]);
  state[2] = safeAdd(c, state[2]);
  state[3] = safeAdd(d, state[3]);
}

function rhex(n: number): string {
  const hex = "0123456789abcdef";
  let output = "";
  for (let j = 0; j < 4; j += 1) {
    output += hex.charAt((n >> (j * 8 + 4)) & 0x0f) + hex.charAt((n >> (j * 8)) & 0x0f);
  }
  return output;
}

function md5(input: string): string {
  const bytes = unescape(encodeURIComponent(input));
  const state = [1732584193, -271733879, -1732584194, 271733878];
  let i = 0;
  for (; i + 64 <= bytes.length; i += 64) {
    md5cycle(state, md5blk(bytes.substring(i, i + 64)));
  }

  const tail = bytes.substring(i);
  const block = new Array<number>(16).fill(0);
  for (let j = 0; j < tail.length; j += 1) {
    block[j >> 2] |= tail.charCodeAt(j) << ((j % 4) * 8);
  }
  block[tail.length >> 2] |= 0x80 << ((tail.length % 4) * 8);
  if (tail.length > 55) {
    md5cycle(state, block);
    block.fill(0);
  }
  block[14] = bytes.length * 8;
  md5cycle(state, block);

  return rhex(state[0]) + rhex(state[1]) + rhex(state[2]) + rhex(state[3]);
}

export function remarkForApi(remark: string): string {
  if (!thaiPattern.test(remark)) {
    return remark;
  }
  return md5(remark);
}
